import React from 'react';
import { Segment, Divider, Table, Button, Icon, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { Selections, Selections2,AntiSkidSelections, offRoadSelections, DSTSelections } from '../../constants';


export function showCertificate(index, type){
    let dc = this.props.certificateDetails;
    let certificateType=[];
    if(type === 'Anti Skid')
        certificateType = AntiSkidSelections;
    if(type === 'Off Road')
        certificateType = offRoadSelections;
    else certificateType = DSTSelections;
    
    return(
        
        <Modal trigger={<Button id='Onay' onClick={() => { this.openPopup(index); }} icon>
            <Icon name='unhide' />
        </Button>}
        style={{backgroundColor: 'rgba(255,255,255,0.5)', maxHeight: '700px', overflowY:'scroll'}}
        >
            <Modal.Header style={{ background: 'rgba(255,255,255,0.52)' }}>{dc['Certificate']}</Modal.Header>
            <Modal.Content style={{backgroundColor:'rgba(0,0,0,0)'}}>
                {this.props.detailsExists &&  
                <Table celled id='antiSkid' textAlign='center' style={{ background: 'rgba(255,255,255,0.52)' }} >
                    <Table.Header style={{ background: 'rgba(255,255,255,0.52)' }}>
                        <Table.Row>
                            <Table.HeaderCell colSpan='4' style={{ backgroundColor: '#000000ba', color: 'white', fontSize: 'medium' }}>Sertifika Bilgileri</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>

                        
                        {Selections2.map((s) => (
                            <Table.Row>
                                <Table.Cell colSpan='2' style ={{width: '50%',fontWeight: 'bold' }}>{s.label}:</Table.Cell>
                                <Table.Cell colSpan='2'>{dc[`${s.id}`]}</Table.Cell>   
                            </Table.Row>
                        ))
                        }  
                        {Selections.map((s2) => (
                            <Table.Row>
                                <Table.Cell colSpan='2' style={{ width: '50%', fontWeight: 'bold'}}>{s2.label}:</Table.Cell>
                                <Table.Cell colSpan='2'>{dc[`${s2.id}`]}</Table.Cell>
                            </Table.Row>
                        ))
                        }   
                    </Table.Body>
                    <Table.Header style={{ background: 'rgba(255,255,255,0.52)' }}>
                        <Table.Row>
                            <Table.HeaderCell colSpan='4' style={{ backgroundColor: '#000000ba',color: 'white', fontSize: 'medium'}}>Degerlendirme</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Header style={{ background: 'rgba(255,255,255,0.52)' }}>
                        <Table.Row>
                            <Table.HeaderCell>Kriter</Table.HeaderCell>
                            <Table.HeaderCell>Puan</Table.HeaderCell>
                            <Table.HeaderCell>Duzelt</Table.HeaderCell>
                            <Table.HeaderCell>Devam Et</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            certificateType.map((s3,i) =>(
                                <Table.Row>
                                    <Table.Cell style={{fontWeight: 'bold'}}>{s3.degerlendirme}</Table.Cell>
                                    <Table.Cell>{dc.Criteria && dc.Criteria[i].Point}</Table.Cell>
                                    <Table.Cell>{dc.Criteria && dc.Criteria[i].Correct}</Table.Cell>
                                    <Table.Cell>{dc.Criteria && dc.Criteria[i].Proper}</Table.Cell>
                                </Table.Row>
                            ))
                        }
                    </Table.Body>
                    <Table.Header style={{ background: 'rgba(255,255,255,0.52)'}}>
                        <Table.Row>
                            <Table.HeaderCell colSpan='4' style={{ backgroundColor: '#000000ba' }}></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Header style={{ background: 'rgba(255,255,255,0.52)'}}>
                        <Table.HeaderCell colSpan='2'>Toplam Puan: </Table.HeaderCell>
                        <Table.HeaderCell colSpan='2'>{dc.TotalPoint} </Table.HeaderCell>
                    </Table.Header>
                </Table>}
                {this.props.detailsLoading &&
                                
                    <Dimmer active inverted style={{ background: 'rgba(255,255,255,0.2)', fontSize: 'medium' }}>
                        <Loader inverted/>
                    </Dimmer>
                }
            </Modal.Content>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/components/PanelPages/showCertificate.jsx